// extracted by mini-css-extract-plugin
export default {"toolbar":"prayerTimes_toolbar__hEuHJ","pickers":"prayerTimes_pickers__7UYVh","month":"prayerTimes_month__qTs0u","year":"prayerTimes_year__bOxIU"};